import React from 'react';

export default function WhatsAppPreview({ node, isVisible, onClose, sidePanel }) {
  if (!isVisible || !node) return null;

  // WhatsApp-style bubble for bot messages
  const botBubbleStyle = {
    background: '#fff',
    border: '1px solid #ece5dd',
    borderRadius: '0 12px 12px 12px',
    padding: '12px 18px',
    maxWidth: '90%',
    fontFamily: 'Segoe UI, Arial, sans-serif',
    fontSize: '16px',
    color: '#222',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    margin: '8px 0',
    display: 'inline-block',
    textAlign: 'left',
    position: 'relative',
    wordBreak: 'break-word',
    lineHeight: 1.6,
  };

  // WhatsApp quick reply button style
  const waButtonStyle = {
    width: '100%',
    background: '#e7f3ff',
    color: '#1976d2',
    border: 'none',
    borderRadius: 8,
    padding: '13px 0',
    fontWeight: 600,
    fontSize: 16,
    margin: '8px 0',
    cursor: 'pointer',
    boxShadow: '0 1px 2px rgba(25,118,210,0.08)',
    transition: 'background 0.18s',
    textAlign: 'center',
    outline: 'none',
  };

  // Panel: phone aspect ratio, right side, rounded corners
  const panelStyle = {
    position: 'fixed',
    top: '50%',
    right: 32,
    transform: 'translateY(-50%)',
    width: 370,
    height: 700,
    background: '#ece5dd',
    boxShadow: '-8px 0 32px rgba(0,0,0,0.18)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 32,
    overflow: 'hidden',
    border: '1.5px solid #bdbdbd',
  };

  // WhatsApp header
  const headerStyle = {
    background: 'linear-gradient(90deg, #075e54 0%, #128c7e 100%)',
    color: '#fff',
    padding: '14px 18px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontWeight: 600,
    fontSize: 17,
    borderBottom: '1.5px solid #128c7e',
  };

  return (
    <div style={panelStyle}>
      {/* WhatsApp Header */}
      <div style={headerStyle}>
        <span
          style={{ fontSize: 22, cursor: 'pointer', marginRight: 8 }}
          onClick={onClose}
          title="Back"
        >
          &#8592;
        </span>
        <img
          src="https://randomuser.me/api/portraits/men/32.jpg"
          alt="avatar"
          style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', border: '2px solid #fff' }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: 16 }}>+91 98765 43210</div>
          <div style={{ fontSize: 12, opacity: 0.8 }}>online</div>
        </div>
        <span style={{ fontSize: 22, cursor: 'pointer', marginLeft: 8 }} onClick={onClose} title="Close">×</span>
      </div>

      {/* Chat Background */}
      <div style={{
        background: 'url("/src/assets/images/wa_chat_bg.png") repeat, #ece5dd',
        flex: 1,
        padding: '32px 18px 0 18px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}>
        {/* Message bubble */}
        <div style={{ textAlign: 'left', marginBottom: 12 }}>
          <span style={botBubbleStyle}>
            {node.data.message || 'Type your message here...'}
          </span>
        </div>
        {/* Quick reply buttons */}
        {node.data.buttons && node.data.buttons.length > 0 && (
          <div style={{ marginTop: 18 }}>
            {node.data.buttons.map((btn, idx) => (
              <button
                key={idx}
                style={waButtonStyle}
                tabIndex={-1}
                disabled
              >
                {btn.label || 'Button ' + (idx + 1)}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
} 